<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <!-- Breadcrumb Section -->
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span class="pointer-none">Auction</span>
                    <a class="pointer-none">Create Auction</a>
                </div>
            </div>
            <div>
                <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                        style="margin: 0 auto;" />
                </div>
                <div v-else-if="!ajaxCallInProgress" class="create-auction-container w-100 pb-4">
                    <div class="main-div">
                        <div class="create-auction-header d-flex align-items-center justify-content-between text-flow">
                            <span class="fs-14  pl-3 text-white ml-3">Auction Information</span>
                            <span class="pointer ml-2" @click="showAuctionInfoData()">
                                <i v-if="!showAuctionInfo" class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                            </span>
                        </div>
                        <!-- Auction Input Information Section -->
                        <div v-if="showAuctionInfo" class="pl-10 pr-10 pt-6">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="w-100">
                                        <span class="input-label">Auction Name<span class="fs-14 text-danger">*</span></span>
                                        <div class="d-flex align-content-center mt-2">
                                            <input type="text" autocomplete="off" name="auction_name" v-validate="'required'" class="input-field input-width" maxlength="100" v-model="auction_name" placeholder="Enter Auction Name" />
                                        </div>
                                        <div class="text-right pr-10">
                                            <span class="float-left text-danger mb-3" v-show="errors.has('auction_name')">Auction Name is Required</span>
                                        </div>
                                        <div class="text-right mt-1">
                                            <span class="input-field-length float-right">{{ auction_name.length }}/100</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="w-100">
                                        <span class="input-label">Auction Creator<span class="fs-14 text-danger">*</span></span>
                                        <div class="d-flex align-content-center mt-2">
                                            <input type="text" v-validate="'required'" autocomplete="off" disabled name="auction_creator" class="input-field input-width" v-model="auction_creator" placeholder="Creator Name" />
                                            <span class="mt-2 ml-1">
                                                <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                            </span>
                                        </div>
                                        <div class="text-left pr-10">
                                            <span class="float-left text-danger mb-3" v-show="errors.has('auction_creator')">Auction Creator is Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 margin-top-res">
                                    <span class="input-label">
                                        Creation Date<span class="fs-14 text-danger">*</span>
                                    </span>
                                    <div class="d-flex align-items-center mt-2">
                                        <date-picker v-model="creation_date" v-validate="'required'" name="creation_date"
                                            disabled
                                            class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                            format="MM-DD-YYYY" value-type="format" type="date" lang="en"
                                            placeholder="Select Creation Date"
                                            :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                        </date-picker>
                                        <span class="mt-1"><i class="icon text-green icon-check-circle"></i></span>
                                    </div>
                                    <div class="text-left pr-10">
                                        <span class="float-left text-danger mb-3" v-show="errors.has('creation_date')">Creation Date is Required</span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 margin-top-res margin-res-992">
                                    <div class="row">
                                        <div class="col-lg-8 col-md-8 col-sm-8">
                                            <span class="input-label">
                                                Auction Opening Date<span class="fs-14 text-danger">*</span>
                                            </span>
                                            <div class="d-flex align-items-center mt-2">
                                                <date-picker v-model="auction_opening_date" v-validate="'required'" name="auction_opening_date"
                                                    :not-before="new Date()"
                                                    @change="checkOpeningTime()"
                                                    class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                                    format="MM/DD/YYYY" value-type="format" type="date" lang="en"
                                                    placeholder="Select Date"
                                                    :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                                </date-picker>
                                            </div>
                                            <div class="text-left pr-10">
                                                <span class="float-left text-danger mb-3" v-show="errors.has('auction_opening_date')">Opening Date Required</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4 pl-0 margin-res-575">
                                            <span class="input-label">
                                                Time<span class="fs-14 text-danger">*</span>
                                            </span>
                                            <el-select
                                                name="auction_opening_time" class="mt-2 schedule_time w-100" v-model="auction_opening_time"
                                                style="border-radius: 6px;border: 1px solid #3f3f3f !important;"
                                                placeholder="Select Time" v-validate="'required'"
                                                @change="checkClosingTime()"
                                                :popper-append-to-body="false">
                                                <el-option v-for="(item, index) in opening_time_format" :key="index"
                                                    :label="item" :value="item">
                                                </el-option>
                                            </el-select>
                                            <div class="text-left pr-10">
                                                <span class="float-left text-danger mb-3" v-show="errors.has('auction_opening_time')">Opening Time Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 margin-top-res margin-res">
                                    <div class="row">
                                        <div class="col-lg-8 col-md-8 col-sm-8">
                                            <span class="input-label">
                                                Auction Closing Date<span class="fs-14 text-danger">*</span>
                                            </span>
                                            <div class="d-flex align-items-center mt-2">
                                                <date-picker v-model="auction_closing_date" name="auction_closing_date"
                                                    :not-before="auction_opening_date" v-validate="'required'"
                                                    :disabled="auction_opening_date == '' || auction_opening_time == ''"
                                                    @change="checkClosingTime()"
                                                    class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                                    format="MM/DD/YYYY" value-type="format" type="date" lang="en"
                                                    placeholder="Select Date"
                                                    :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                                </date-picker>
                                            </div>
                                            <div class="text-left pr-10">
                                                <span class="float-left text-danger mb-3" v-show="errors.has('auction_closing_date')">Closing Date Required</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4 pl-0 margin-res-575">
                                            <span class="input-label">
                                                Time<span class="fs-14 text-danger">*</span>
                                            </span>
                                            <el-select
                                                name="auction_closing_time" class="mt-2 schedule_time w-100" v-model="auction_closing_time"
                                                style="border-radius: 6px;border: 1px solid #3f3f3f !important;"
                                                placeholder="Select Time" v-validate="'required'"
                                                :disabled="auction_opening_date == '' || auction_opening_time == '' || auction_closing_date == ''"
                                                :popper-append-to-body="false">
                                                <el-option v-for="(item, index) in closing_time_format" :key="index"
                                                    :label="item" :value="item">
                                                </el-option>
                                            </el-select>
                                            <div class="text-left pr-10">
                                                <span class="float-left text-danger mb-3" v-show="errors.has('auction_closing_time')">Closing Time Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 mt-6">
                                    <span class="input-label">
                                        Description
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <textarea-autosize class="digi-textarea white-background bordered" name="description" placeholder="Add Description" maxlength="1000" v-model="description" style="height: 44px !important;overflow: overlay !important;"/>
                                    </div>
                                    <div class="text-right mt-1">
                                        <span class="input-field-length float-right">{{ description.length }}/1000</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Auction table Section -->
                        <div class="create-auction-header d-flex align-items-center justify-content-between text-flow mt-6">
                            <span class="fs-14  pl-3 text-white ml-3">Auctions Items Details</span>
                            <span class="pointer ml-2" @click="showAuctionItemsDetals()">
                                <i v-if="!showAuctionItems" class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                            </span>
                        </div>
                        <div v-if="showAuctionItems" class="pl-10 pr-10 pt-6">
                            <div class="input-label">Configure Table:</div>
                            <div class="table-div mt-4 p-4" v-for="(table, table_index) in auction_table" :key="table_index">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="input-label">Table {{table_index + 1}}:</div>
                                    <div v-if="auction_table.length > 1"><i class="icon icon-trash text-danger fs-22 pr-1 pointer" @click="deleteTable(table_index)"></i></div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-12">
                                        <div class="w-100">
                                            <div class="d-flex align-items-center mt-2">
                                                <div class="input-label ml-4 pr-4 row-padding-right">Rows<span class="fs-14 text-danger">*</span></div>
                                                <input type="text" autocomplete="off"
                                                    :name="'rows'+table_index" class="input-field input-width" 
                                                    v-model="table.rows" @input="validateRow($event, table_index)" placeholder="Enter Number of Rows" v-validate="'required'"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"/>
                                            </div>
                                            <div class="text-left pr-10 pl-20">
                                                <span class="float-left text-danger mb-3" v-show="errors.has('rows'+table_index)">Rows Required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12">
                                        <div class="w-100">
                                            <div class="d-flex align-items-center mt-2">
                                                <div class="input-label ml-4 pr-4">Column<span class="fs-14 text-danger">*</span></div>
                                                <input type="text" autocomplete="off"
                                                    :name="'columns'+table_index" class="input-field input-width" 
                                                    v-model="table.columns" @input="validateCol($event, table_index)" placeholder="Enter Number of Columns" v-validate="'required'"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"/>
                                            </div>
                                            <div class="text-left pr-10 pl-25">
                                                <span class="float-left text-danger mb-3" v-show="errors.has('columns'+table_index)">Column Required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-12 col-sm-12">
                                        <button v-if="table.table_loader == true" class="btn btn-add fw-600 fs-14 ml-5" disabled @click="addTableCells(table_index)">+ Add
                                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                        </button>
                                        <button v-else class="btn btn-add fw-600 fs-14 ml-5" @click="addTableCells(table_index)">+ Add</button>
                                    </div>
                                    <!-- :disabled="table.table_data.length > 0" :class="{'disable-btn':table.table_data.length > 0}" -->
                                </div>
                                <div class="d-flex align-items-center justify-content-center h-100 mt-10 mb-10" v-if="table.table_loader">
                                    <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b"
                                        style="margin: 0 auto;" />
                                </div>
                                <div v-if="table.table_loader == false && table.table_data.length == 0">
                                    <div class="table-name-section mt-8 text-white fs-14 fw-600 pt-2 pl-4">
                                        Add Table
                                    </div>
                                    <div class="text-blace fs-14 mt-6 fw-500 d-flex justify-content-center align-items-center" style="border: 1px solid black; border-radius: 5px; height: 150px;">No Tables added yet!</div>
                                </div>
                                <div v-if="table.table_loader == false && table.table_data.length > 0">
                                    <div class="table-name-section mt-8">
                                        <input type="text" autocomplete="off" v-validate="'required'" :name="'table_name'+table_index" class="table-input-field" v-model="table.table_name" placeholder="Enter Table Name" />
                                    </div>
                                    <div>
                                        <span class="text-danger pl-4" v-show="errors.has('table_name'+table_index)">Table Name is Required</span>
                                    </div>
                                    <!-- <div class="mt-4">
                                        <span class="fw-500 fs-14 pl-4" style="color: #00448b;">Note: Select the columns where you allow the user to input data in Auction.</span>
                                    </div> -->
                                    <div style="overflow: auto;">
                                        <table class="auction-data-table mt-4 mb-4" style="width: 100% !important;text-align: left;padding-left: 10px;">
                                            <tbody>
                                                <tr v-for="(row, row_index) in table.table_data"
                                                    :key="row_index">
                                                    <td v-for="(col, col_index) in row" :key="col_index"
                                                        style="height: 38px;" class="pl-5">
                                                        <!-- <label v-if="row_index == 0" class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                            <input type="checkbox" class="custom-control-input" v-model="col.checked" @change="selectOne($event, table_index, col_index)"/>
                                                            <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;color: #fff !important;"></span>
                                                            <span class="form-check-description fw-600"></span>
                                                        </label> -->
                                                        <input type="text" v-model="row[col_index]" :name="'table_data'+table_index" v-validate="'required'" :placeholder='row_index == 0 ? "Enter Heading" : "Enter Data"' />
                                                    </td>
                                                    <span v-if="row_index != 0 && table.table_data.length > 2"><a class="text-danger pointer" @click="removeRow(table_index, row_index)"><i class="icon icon-trash text-danger fs-18 pr-1"></i>Delete</a></span>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr v-for="(row, row_index) in table.table_data"
                                                    :key="row_index">
                                                    <template v-for="(col, col_index) in row">
                                                        <td v-if="row_index == 0 && table.table_data[0].length > 1" :key="col_index" class="text-danger text-left pt-2 pl-5">
                                                            <a class="pointer" @click="removeColumn(table_index, col_index)"><i class="icon icon-trash text-danger fs-18 pr-1"></i>Delete</a>
                                                        </td>
                                                    </template>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                <div>
                                    <span class="text-danger" v-show="errors.has('table_data'+table_index)">All fields are Required</span>
                                </div>
                            </div>
                            <div class="row" style="display: initial;">
                                <button class="btn btn-new-add fw-600 fs-14 ml-5" @click="addTable()">+ Add Table</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="disableButtonAndDisplayLoader == false" class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-6">
                        <button class="btn mt-2 ml-6 new-cancel-button" @click="gotoListView()">Cancel</button>
                        <button class="btn mt-2 ml-6 new-save-button" @click="validateAuction()">Preview</button>
                    </div>
                    <div v-else class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-6">
                        <button class="btn mt-2 ml-6 new-cancel-button" disabled style="border: none !important;">Cancel</button>
                        <button class="btn mt-2 ml-6 new-save-button" style="position: relative;" disabled>Preview
                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import { HollowDotsSpinner } from "epic-spinners";
import { EventBus } from '../eventBus/nav-bar-event';
import { SweetModal } from 'sweet-modal-vue';
import moment from 'moment';
export default {
    data(){
        return {
            success_msg: '',
            warning_msg: '',
            auction_table: [{
                rows: null,
                columns: null,
                table_name: "",
                table_data: [],
                editable_columns: [],
                table_loader: false,
            }],
            ajaxCallInProgress: false,
            disableButtonAndDisplayLoader: false,
            showAuctionInfo: true,
            showAuctionItems: true,
            auction_name: "",
            auction_creator: "",
            creation_date: moment(new Date().toUTCString()).format("MM/DD/YYYY"),
            auction_opening_date: "",
            auction_opening_time: "",
            auction_closing_date: "",
            auction_closing_time: "",
            opening_time_format: [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ],
            closing_time_format: [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ],
            description: "",
            auction_template_data: {},
            editable_column_index: [],
        }
    },
    components: {
            HalfCircleSpinner,
            HollowDotsSpinner,
            SweetModal,
        },
    methods: {
        //Method to delete created table
        deleteTable(index){
            this.$swal({
                title: 'Once you delete the table, data saved will be lost. Are you sure want to delete it?',
                type: 'warning',
                icon: 'alert',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonColor:'#00448b',
                confirmButtonText:'Yes',
                cancelButtonText:'No'
            }).then((result) => {
                if (result.value) {
                    this.auction_table.splice(index, 1)
                }
            })
        },
        //Checks minimum and maximum value for row
        validateRow(event, table_index){
            if(event.target.value > 500){
                this.auction_table[table_index].rows = 500
            } else if(this.auction_table[table_index].rows == 0){
                this.auction_table[table_index].rows = null
            } else {
                this.auction_table[table_index].rows = event.target.value
            }
        },
        //Checks minimum and maximum value for column
        validateCol(event, table_index){
            if(event.target.value > 15){
                this.auction_table[table_index].columns = 15
            } else if(event.target.value == 0){
                this.auction_table[table_index].columns = null
            } else {
                this.auction_table[table_index].columns = event.target.value
            }
        },
        // selectOne(event, table_index, column_index){
        //     if(event.target.checked){
        //         this.auction_table[table_index].table_data.forEach((el, index) => {
        //             if(index == 0){
        //                 if(el[column_index] == ''){
        //                     this.warning_msg = 'Please Enter Column Heading'
        //                     this.$refs.warning_modal.open();
        //                     setTimeout(() => {
        //                         this.$refs.warning_modal.close();
        //                     }, 3000);
        //                 } else {
        //                     this.auction_table[table_index].editable_columns.push(el[column_index])
        //                 }
        //             }
        //         })
        //     } else {
        //         this.auction_table[table_index].editable_columns.forEach((del_edit_col, del_edit_col_index) => {
        //             this.auction_table[table_index].table_data.forEach((el, index) => {
        //                 if(del_edit_col == el[column_index]){
        //                     this.auction_table[table_index].editable_columns.splice(del_edit_col_index, 1)
        //                 }
        //             })
        //         })
        //     }
        // },
        //Alert popup to warn delete row
        removeRow(table_index, row_index){
            this.$swal({
                title: 'Once you delete the row, data saved will be lost. Are you sure want to delete it?',
                type: 'warning',
                icon: 'alert',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonColor:'#00448b',
                confirmButtonText:'Yes',
                cancelButtonText:'No'
            }).then((result) => {
                if (result.value) {
                    this.auction_table[table_index].table_data.splice(row_index, 1)
                    this.auction_table[table_index].rows = this.auction_table[table_index].rows - 1
                }
            })
        },
        //Alert popup to warn delete column
        removeColumn(table_index, col_index){
            this.$swal({
                title: 'Once you delete the column, data saved will be lost. Are you sure want to delete it?',
                type: 'warning',
                icon: 'alert',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonColor:'#00448b',
                confirmButtonText:'Yes',
                cancelButtonText:'No'
            }).then((result) => {
                if (result.value) {
                    this.auction_table[table_index].table_data.forEach((column_el, column_el_index) => {
                        column_el.splice(col_index, 1)
                    })
                    this.auction_table[table_index].columns = this.auction_table[table_index].columns - 1
                }
            })
        },
        //Create rows and columns for a table
        addTableCells(index){
            this.auction_table[index].table_loader = true;
            let row_num = this.auction_table[index].rows == null ? 1 : parseInt(this.auction_table[index].rows) + 1;
            let col_num = this.auction_table[index].columns == null ? 0 : parseInt(this.auction_table[index].columns);
            if(row_num - 1 != 0 && col_num != 0 ){
                if(this.auction_table[index].table_data.length == 0){
                    for (let i = 0; i < row_num ; i++) {
                        let cell = [];
                        for (let j = 0; j < col_num; j++) {
                            cell[j] = ""
                        }
                        this.auction_table[index].table_data.push(cell);
                    }
                } else {
                    if(this.auction_table[index].table_data.length <= row_num){
                        let row = row_num - this.auction_table[index].table_data.length
                        for(let i=0; i<row; i++){
                            let cell = []
                            for(let j=0; j<col_num; j++){
                                cell.push("");
                            }
                            this.auction_table[index].table_data.push(cell);
                        }
                        this.auction_table[index].table_data.forEach((x) => {
                            if(x.length < col_num){
                                let column = col_num - x.length
                                for (let i =0; i < column; i++) {
                                    x.push("");
                                }
                            } else if(x.length > col_num){
                                let column = x.length - col_num
                                for (let i = 0; i < column; i++) {
                                    x.pop();
                                }
                            }
                        });
                    } else if(this.auction_table[index].table_data.length > row_num){
                        let row = this.auction_table[index].table_data.length - row_num
                        for (let i = 0; i < row; i++) {
                            let cell = [];
                            for (let i = 0; i < col_num; i++) {
                                cell.pop();
                            }
                            this.auction_table[index].table_data.pop(cell);
                        }
                        this.auction_table[index].table_data.forEach((x) => {
                            if(x.length < col_num){
                                let column = col_num - x.length
                                for (let i =0; i < column; i++) {
                                    x.push("");
                                }
                            } else if(x.length > col_num){
                                let column = x.length - col_num
                                for (let i = 0; i < column; i++) {
                                    x.pop();
                                }
                            }
                        })
                    }
                }
            } else {
                this.warning_msg = 'Please Enter Rows and Columns'
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
            setTimeout(() => {
                this.auction_table[index].table_loader = false;
            }, 1000);
        },
        //Adds empty table
        addTable(){
            this.auction_table.push({
                rows: null,
                columns: null,
                table_name: "",
                table_data: [],
                editable_columns: [],
                table_loader: false,
            })
        },
        //Redirects to auction list view page
        gotoListView(){
            this.$router.push('/auction/listview')
        },
        //Validates mandatory fields and redirects to preview page
        validateAuction(){
            this.$validator.validateAll().then(result =>{
                if(result){
                    this.auction_table.forEach((table, table_index) => {
                        if(table.rows != (table.table_data.length - 1)){
                            if(table.table_data.length == 0){
                                this.warning_msg = 'Click on "Add" Button to create Table.'
                            } else {
                                this.warning_msg = 'In order to update new rows, you have to Click on "Add" Button otherwise, it will contine with earlier selected rows.'
                            }
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                if(table.table_data.length == 0){
                                    this.auction_table[table_index].rows = this.auction_table[table_index].rows
                                    this.auction_table[table_index].columns = this.auction_table[table_index].columns
                                } else {
                                    this.auction_table[table_index].rows = table.table_data.length -1
                                }
                                this.$refs.warning_modal.close();
                            }, 5000);
                        } else if(table.columns != table.table_data[0].length){
                            this.warning_msg = 'In order to update new columns, you have to Click on "Add" Button otherwise, it will contine with earlier selected column.'
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.auction_table[table_index].columns = table.table_data[0].length
                                this.$refs.warning_modal.close();
                            }, 5000);
                        } else {
                            this.disableButtonAndDisplayLoader = true
                            localStorage.setItem('auction_template_data', JSON.stringify(this.createMainJsonData))
                            setTimeout(() => {
                                this.$router.push({
                                    path: "/auction/preview"
                                })
                                this.disableButtonAndDisplayLoader = false
                            }, 1000);
                        }
                    })
                } else {
                    this.disableButtonAndDisplayLoader = false
                }
            })
            this.disableButtonAndDisplayLoader = false
        },
        showAuctionInfoData(){
            if (this.showAuctionInfo == true){
                this.showAuctionInfo = false;
            } else {
                this.showAuctionInfo = true
            } 
        },
        showAuctionItemsDetals(){
            if (this.showAuctionItems == true){
                this.showAuctionItems = false;
            } else {
                this.showAuctionItems = true
            } 
        },
        ////validates opening time with current time to show future time
        checkOpeningTime(){
            var curr_date = moment(new Date().toUTCString()).format("MM/DD/YYYY")
            this.auction_opening_time = "";
            this.auction_closing_date = "";
            this.auction_closing_time = "";
            this.opening_time_format = [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ]
            if(this.auction_opening_date == curr_date){
                var temp_start_time = ""
                var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                    temp_start_time = curr_time.slice(0,3) + '00'
                } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                    temp_start_time = curr_time.slice(0,3) + '15'
                } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                    temp_start_time = curr_time.slice(0,3) + '30'
                } else if(parseInt(curr_time.substring(3)) >= 45){
                    temp_start_time = curr_time.slice(0,3) + '45'
                }
                let indx = this.opening_time_format.indexOf(temp_start_time)
                this.opening_time_format.splice(0,indx+1)
            }
        },
        //validates closing time with current time to show future time
        checkClosingTime(){
            this.auction_closing_time = "";
            this.closing_time_format = [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ]
            if(this.auction_opening_date == this.auction_closing_date){
                var temp_start_time = ""
                var curr_time = this.auction_opening_time
                if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                    temp_start_time = curr_time.slice(0,3) + '00'
                } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                    temp_start_time = curr_time.slice(0,3) + '15'
                } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                    temp_start_time = curr_time.slice(0,3) + '30'
                } else if(parseInt(curr_time.substring(3)) >= 45){
                    temp_start_time = curr_time.slice(0,3) + '45'
                }
                let indx = this.closing_time_format.indexOf(temp_start_time)
                this.closing_time_format.splice(0,indx+1)
            }
        },
    },
    mounted(){
        EventBus.$on("back_from_preview_auction", ()=>{
            if(localStorage.getItem("auction_template_data")){
                this.auction_template_data = JSON.parse(localStorage.getItem("auction_template_data"))
                this.auction_name = this.auction_template_data.auction_info.auction_name
                this.auction_creator = this.auction_template_data.auction_info.auction_creator_name
                this.creation_date = moment(new Date().toUTCString()).format("MM/DD/YYYY"),
                this.auction_opening_date = this.auction_template_data.auction_info.auction_opening_date
                this.auction_opening_time = this.auction_template_data.auction_info.auction_opening_time
                this.auction_closing_date = this.auction_template_data.auction_info.auction_closing_date
                this.auction_closing_time = this.auction_template_data.auction_info.auction_closing_time
                this.description = this.auction_template_data.auction_info.description
                this.auction_table = this.auction_template_data.table_info.table_details
            }
        })
        this.auction_creator = this.loggedInUser.full_name;
    },
    computed: {
        createMainJsonData() {
            return {
                "auction_info": {
                    "auction_name": this.auction_name,
                    "auction_creator": this.loggedInUser.id,
                    "auction_creator_name": this.auction_creator,
                    "auction_opening_date": this.auction_opening_date,
                    "auction_opening_time": this.auction_opening_time,
                    "auction_closing_date": this.auction_closing_date,
                    "auction_closing_time": this.auction_closing_time,
                    "description": this.description
                },
                "table_info": {
                    "no_of_tables": this.auction_table.length,
                    "table_details": this.auction_table
                }
            }
        },
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
    },
}
</script>
<style scoped>
    .create-auction-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }
    .create-auction-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #00448b;
        padding: 0 0 6px 0px;
        font-size: 14px;
    }
    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        color: black;
        font-size: 14px !important;
        font-weight: 600;
    }
    .table-input-field {
        border-bottom: 1px solid #fff !important;
        padding: 10px 16px 4px 10px !important;
        margin-left: 15px !important;
        width: 20% !important;
        color: #fff !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        background-color: #00448b !important;
    }
    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }
    .btn-new-preview{
        padding: 0 10px !important;
		border-radius: 5px !important;
		font-size: 14px !important;
		line-height: 30px !important;
		text-transform: none !important;
		font-weight: 600 !important;
		color: #fff !important;    
	    background-color: #00448b !important;
    }
    .table-div{
        border: 1px solid black;
        border-radius: 5px;
        height: auto;
    }
    .btn-add{
        padding: 0 10px !important;
		border-radius: 5px !important;
		font-size: 14px !important;
        width: 150px;
		text-transform: none !important;
		font-weight: 600 !important;
		color: #fff !important;    
	    background-color: #1E7209 !important;
        margin-top: 12px;
        float: right;
    }
    .btn-add:disabled {
        background-color: #848484 !important;
    }
    .disable-btn{
        background-color: #848484 !important;
    }
    .btn-new-add{
        padding: 0 10px !important;
		border-radius: 5px !important;
		font-size: 14px !important;
        width: 150px;
		text-transform: none !important;
		font-weight: 600 !important;
		color: #fff !important;    
	    background-color: #00448b !important;
        margin-top: 12px;
        float: right;
    }
    .table-name-section{
        height: 40px !important;
        background-color: #00448b !important;
    }
    @media only screen and (min-width: 0px) and (max-width: 767px) {
        .row-padding-right{
            padding-right: 36px !important;
        }
    }
    .delete-btn{
        background-color: #fff !important;
    }
    .pointer-none{
        cursor: default !important;
    }
    @media screen and (max-width: 767px) {
		.margin-top-res {
            margin-top: 20px !important;
		}
	}
    @media screen and (max-width: 575px) {
		.margin-res-575 {
            margin-top: 20px !important;
            margin-left: 16px !important;
		}
	}
    @media screen and (min-width: 768px) {
		.margin-res {
            margin-top: 20px !important;
		}
	}
    @media screen and (min-width: 992px) {
		.margin-res-992 {
            margin-top: 20px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Auction/CreateAuction.vue